import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=4d0c4bc7&scoped=true&"
import script from "./productTable.vue?vue&type=script&lang=js&"
export * from "./productTable.vue?vue&type=script&lang=js&"
import style0 from "./productTable.vue?vue&type=style&index=0&id=4d0c4bc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c4bc7",
  null
  
)

export default component.exports